"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default() {
  return function ({
    addUtilities,
    variants
  }) {
    addUtilities({
      '.items-start': {
        'align-items': 'flex-start'
      },
      '.items-end': {
        'align-items': 'flex-end'
      },
      '.items-center': {
        'align-items': 'center'
      },
      '.items-baseline': {
        'align-items': 'baseline'
      },
      '.items-stretch': {
        'align-items': 'stretch'
      }
    }, variants('alignItems'));
  };
}